module.exports = __webpack_public_path__ + "static/media/postgresql-vs-mysql-performance-benchmarking.4a7cb71b.md";